export default __webpack_public_path__ + "static/media/bonus_icon.dbae9fd8.svg";